import type { CSSProperties } from 'react';
import type { Index } from '@balansa/shared';

/** Jomas nosaukums ar krāsainu punktu. */
export function Cn({ idx, id }: { idx: Index; id: string }) {
  if (!idx.node.has(id)) return <span className="cn">(dzēsta joma)</span>;
  return (
    <span className="cn" style={{ '--c': idx.color(id) } as CSSProperties}>
      {idx.node.get(id)!.name}
    </span>
  );
}
